import React from 'react';
import { IconButton, Tooltip, Typography } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import SyncAltIcon from '@material-ui/icons/SyncAlt';

const useStyles = makeStyles(() =>
    createStyles({
        button: {
            width: 30,
            height: 30,
        },
    }),
);

interface FieldSwitchButtonProps {
    tooltip: string;
    onClick: () => void;
}

// The button that swaps a name field between typing a new name and picking an existing one. It sits inside the field as an end adornment
// (like the Last Name field's), instead of in a column beside it.
export const FieldSwitchButton: React.FC<FieldSwitchButtonProps> = ({ tooltip, onClick }) => {
    const classes = useStyles();
    return (
        <Tooltip title={<Typography color="inherit">{tooltip}</Typography>}>
            <IconButton aria-label={tooltip} className={classes.button} onClick={onClick}>
                <SyncAltIcon fontSize="small" />
            </IconButton>
        </Tooltip>
    );
};
